import { html } from "lit-element";
import { DrawSVGBaseModule } from "../../ModuleBase/svg-base-module";

export class DrawSluisHor1Module extends DrawSVGBaseModule {
	constructor(canvas) {
		super(canvas);

		this.name = "sluis-hor-1";
		this.icon = svg_sluis_hor_1;
	}
}

window.customElements.define("inspx-draw-sluis-hor-1-module", DrawSluisHor1Module);

const svg_sluis_hor_1 = html`
<svg width="90" height="45" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
<g>
 <title>Layer 1</title>
 <rect stroke="#444444" id="svg_2" height="44.7166" width="90" fill="#ffffff"/>
 <line stroke="#444444" id="svg_1" y2="0" x2="30" y1="44.01581" x1="30" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" fill="none"/>
 <line stroke="#444444" id="svg_3" y2="0" x2="60" y1="44.61649" x1="60" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" fill="none"/>
 <text stroke="#444444" transform="matrix(0.7865640806243794,0,0,0.8817506323334106,-25.8787736418564,-18.065804772613273) " xml:space="preserve" text-anchor="middle" font-family="Sans-serif" font-size="24" id="svg_4" y="53.76739" x="91.05168" stroke-linecap="null" stroke-linejoin="null" stroke-dasharray="null" stroke-width="0" fill="#000000">sluis</text>
</g>
</svg>
`;
